import getBundleList from '../../Services/productBundles/productBundlesService';

export default async function renderCount(searchValue, size, pageNumber, fetch) {
    let getBundleProd = await getBundleList(searchValue, size, pageNumber, fetch);

    return getBundleProd.totalCount;
}